module.exports = "\r\n    <div class=\"container\">\r\n    </div>\r\n"